import React from 'react'
import { Button, Dropdown, Menu } from 'antd'
import { DataTable } from './DataTable'
import { YhBox } from '@/components/YhBox'
import { DescriptionColorEnum, IDescription } from '@/components/YhBox/Types'
import useNavModel from '@/model/navModel'
import { globalPrompt } from '@/components/message'
import { YhAuth } from '@/components/auth/YhAuth'
import { useAssetsInventoryDetailsModel } from './details/assetsInventoryDetailsModel'
import { useAssetsInventoryModel } from '../assetsInventoryModel'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import { PlusOutlined } from '@ant-design/icons'
import { MaterialCodeModal } from './details/materialModel'
import { DictCodeEnmu } from "@/types/AppDictEnums";

export const DataBox = () => {
    const { selectedRowKeys, statistics, exportData,dataSource } = useAssetsInventoryModel()
    const { resetEditCatch,getSDcDetailOne,setMaterialCodeVisible,materialCodeVisible } = useAssetsInventoryDetailsModel()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => [])

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt('message', { text: '单据不是进行中状态，无法编辑', type: 'warning' })
            return
        }
        let newSourse:any=dataSource.find((item)=>item.id==selectedRowKeys[0])
        if (newSourse.status !== DictCodeEnmu.ASSETS_STOCKTAKING_CREATE) {
            globalPrompt('message', { text: '请选择单条数据进行编辑，点击鼠标右键可一键选中哦！', type: 'warning' })
            return
        }
        let AssetsInventoryEditKey = '3-1-2'
        let isFindNav = findNav(AssetsInventoryEditKey)
        if (!isFindNav) {
            addNav(AssetsInventoryEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
            resetEditCatch()
        } else {
            globalPrompt('modal', {
                title: '物资盘点跳转详情',
                type: 'warning',
                text: '您还有物资盘点详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(AssetsInventoryEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
                    resetEditCatch()
                },
            })
        }
    }
    const onLook = (value) => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt('message', { text: '请选择单条数据进行编辑，点击鼠标右键可一键选中哦！', type: 'warning' })
            return
        }
        let newSourse:any=dataSource.find((item)=>item.id==selectedRowKeys[0])
        if (value=='finish'&&newSourse.status !== DictCodeEnmu.ASSETS_STOCKTAKING_CREATE) {
            globalPrompt('message', { text: '单据不是进行中状态，无法盘点完成', type: 'warning' })
            return
        }
        if (value=='check'&&newSourse.status !== DictCodeEnmu.ASSETS_STOCKTAKING_COMPLETE) {
            globalPrompt('message', { text: '单据不是已完成状态，无法盘点审核', type: 'warning' })
            return
        }
        let AssetsInventoryEditKey = '3-1-3'
        let isFindNav = findNav(AssetsInventoryEditKey)
        if (!isFindNav) {
            addNav(AssetsInventoryEditKey, { id: selectedRowKeys[0] as string, mode: 'look' })
            resetEditCatch()
        } else {
            globalPrompt('modal', {
                title: '物资盘点跳转详情',
                type: 'warning',
                text: '您还有物资盘点详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(AssetsInventoryEditKey, { id: selectedRowKeys[0] as string, mode: 'look' })
                    resetEditCatch()
                },
            })
        }
    }

    const action = (
        <>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_ST_STTAKE_AD}>
            <Button className="mr-5" type="link" shape="round" onClick={() => addNav('3-1-1', { id: '', mode: 'add' })}>
            <PlusOutlined />
                盘点
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_ST_STTAKE_ED}>
            <Button className="mr-5" type="link" shape="round" onClick={onEdit}>
                编辑
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum. ASSETS_ST_STTAKE_FINISH}>
            <Button className="mr-5" type="link" shape="round" onClick={()=>onLook('finish')}>
                盘点完成
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_ST_STTAKE_EXAMINE}>
            <Button className="mr-5" type="link" shape="round" onClick={()=>onLook('check')}>
                盘点审核
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_ST_STTAKE_EX}>
            <Button className="mr-5" type="link" shape="round" onClick={() => exportData()}>
                导出
            </Button>
            </YhAuth>
        </>
    )

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}
